import { importDependency } from 'core-components/helpers'
import { IAppStoreRemoteReducers } from 'core/components/app/models/IAppStore'

export const hpscoutsoRemoteReducers: IAppStoreRemoteReducers[] = [
  {
    key: 'amplifyImpact',
    initReducer: async () => {
      return importDependency(
        'amplifyImpact/Reducer',
        () => import('amplifyImpact/Reducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
  {
    key: 'checkEngine',
    initReducer: async () => {
      return importDependency(
        'checkEngine/ceReducer',
        () => import('checkEngine/ceReducer'),
        (data) => {
          return data
        }
      )
    },
  },
  {
    key: 'remoteKbase',
    initReducer: async () => {
      return importDependency(
        'remoteKbase/kbaseReducer',
        () => import('remoteKbase/kbaseReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
  {
    key: 'remoteDocflow',
    initReducer: async () => {
      return importDependency(
        'remoteDocflow/docflowReducer',
        () => import('remoteDocflow/docflowReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
]
